module.exports = __webpack_public_path__ + "static/cursos-pos-5069fecfa4354ea7df21200f88b7a381.png";